import script from "./writeoff.vue?vue&type=script&setup=true&lang=js"
export * from "./writeoff.vue?vue&type=script&setup=true&lang=js"

import "./writeoff.vue?vue&type=style&index=0&id=40bcf356&scoped=true&lang=scss"
import "./writeoff.vue?vue&type=style&index=1&id=40bcf356&lang=css"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bcf356"]])

export default __exports__